import {
  FacebookOutlined,
  PhoneOutlined,
  UserOutlined,
} from '@ant-design/icons'
import AddIcon from '@mui/icons-material/Add'
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh'
import DeleteIcon from '@mui/icons-material/Delete'
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred'
import {
  Box,
  Button,
  Card,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
} from '@mui/material'
import Typography from '@mui/material/Typography'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { Flex, message, Table } from 'antd'
import dayjs, { Dayjs } from 'dayjs'
import { useFormik } from 'formik'
import { useCallback, useState } from 'react'
import * as Yup from 'yup'

import { useDispatch } from 'react-redux'
import {
  closeModal,
  openModal,
} from '../../../../../store/reducers/modal/modal.slice'
import CircularLoading from '../../../../components/CircularProgress'
import ConfirmOrderModal from '../../../../components/ConfirmOrderModal'
import { ContentWrapper } from '../../../../components/ContentWrapper'
import Helmet from '../../../../components/Helmet'
import InputUpload from '../../../../components/InputUpload'
import HeaderContent from '../../../../components/Layouts/HeaderContent'
import SelectSearch, {
  IOptionSelect,
} from '../../../../components/SelectSearch'
import ChannelSelectSearch from '../../../../components/SelectSearch/ChannelSelectSearch'
import UserSelectSearch from '../../../../components/SelectSearch/UserSelectSearch'
import { ERRORS_MESSAGE_MAPPER } from '../../../../constants/errors'
import { ONLY_DATE_FORMAT } from '../../../../constants/global'
import useAxios, { axiosInstance } from '../../../../hooks/useAxios'
import { useUser } from '../../../../hooks/useUser'
import { IAddress, IAddressThailand } from '../../../../types/address'
import { IDistributionChannel } from '../../../../types/distribution-channel'
import { EOrderStatus, IOrder, OrderSummary } from '../../../../types/order'
import { PaginationResponseInterface } from '../../../../types/pagination'
import { IProduct } from '../../../../types/product'
import { IUserLists } from '../../../../types/user'
import { parseThaiAddress } from '../../../../utils/address'
import { validateMinMaxValue } from '../../../../utils/validateMinMaxValue'
import { OrderFormAddProductModal } from '../OrderList/components/OrderFormAddProductModal'
import { IRemotesArea } from '../../../../types/remote-area'
import { AllowShippingProviderLists } from '../../../../utils/provider'
import { PropertyList } from '../../../../components/PropertyList'
import { PropertyListItem } from '../../../../components/PropertyListItem'
import OrderSelectSearch from '../../../../components/SelectSearch/OrderSelectSearch'

interface IProductsForm {
  product?: IProduct
  quantity?: number
  discount?: number
  size?: string
  isFree?: string
}

interface IOrderForm {
  name: string
  phone: string
  address: string
  subDistrict: string
  district: string
  province: string
  zipcode: string
  social: string
  isCOD: number
  products: IProductsForm[]
  orderDate: string | Dayjs
  paymentDate: string | Dayjs
  distribution: string
  paymentUrl: string
  note: string
  commissionUsername: string
  assignTelesaleBy: string
}

const Menus: any[] = []

const getOrderFormValidationSchema = () => {
  return Yup.object({
    name: Yup.string().required('กรุณากรอกชื่อ-นามสกุล'),
    phone: Yup.string()
      .required('กรุณากรอกหมายเลขโทรศัพท์')
      .matches(/^[0-9]+$/, 'กรุณากรอกหมายเลขโทรศัพท์เป็นตัวเลข'),
    address: Yup.string().required('กรุณากรอกที่อยู่'),
    subDistrict: Yup.string().required('กรุณากรอกตำบล'),
    district: Yup.string().required('กรุณากรอกอำเภอ'),
    province: Yup.string().required('กรุณากรอกจังหวัด'),
    zipcode: Yup.string().required('กรุณากรอกรหัสไปรษณีย์'),
    social: Yup.string(),
    orderDate: Yup.string().required('กรุณาเลือกวันที่สั่งซื้อ'),
    //products: Yup.array().min(1, 'กรุณาเลือกสินค้าอย่างน้อย 1 รายการ'),
    isCOD: Yup.number().required(),
    paymentDate: Yup.string(),
    distribution: Yup.string(),
    paymentUrl: Yup.string(),
    note: Yup.string(),
    commissionUsername: Yup.string(),
    assignTelesaleBy: Yup.string(),
  })
}

const initRemoteAdrea = {
  remote: {
    flash: false,
    kerry: false,
    jnt: false,
    spx: false,
    thaipost: false,
  },
  toure: {
    flash: false,
    kerry: false,
    jnt: false,
    spx: false,
    thaipost: false,
  },
}

const OrderCreatePage = () => {
  const [searchAddress, setSearchAddress] = useState<string>('')
  const [searchOrder, setSearchOrder] = useState<string>('')
  const [searchProduct, setSearchProduct] = useState<string>('')
  const [searchType, setSearchType] = useState<string>('customer_name')
  const [searchUserCommission, setSearchUserCommission] = useState<string>('')
  const [searchUserTelesales, setSearchUserTelesales] = useState<string>('')
  const [searchDistributionChannel, setSearchDistributionChannel] =
    useState<string>('')
  const [isModalAddProduct, setIsModalAddProduct] = useState<boolean>(false)
  const [formatAddress, setFormatAddress] = useState<string>('')
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [resetAutoComplete, setResetAutoComplete] = useState<string>('')
  const [remoteArea, setRemoteArea] = useState<any>(initRemoteAdrea)
  const dispatch = useDispatch()
  const { merchant } = useUser()

  const handleCheckCustomerWarning = async (values: IOrderForm) => {
    try {
      const responseDuplicateOrder = await axiosInstance.post<{
        isDuplicate: boolean
        duplicate: IOrder[]
      }>('/order/check/duplicate', {
        name: values.name,
        phone: values.phone,
        day: merchant.config?.dulplicateOrderDate ?? 1,
      })

      let isWarning
      const title = []
      if (responseDuplicateOrder?.data?.isDuplicate) {
        isWarning = true
        title.push(
          `เตือน! ลูกค้า ${values.name} มีคำสั่งซื้อซ้ำในระยะเวลา ${
            merchant.config?.dulplicateOrderDate ?? 1
          } วันที่ผ่านมา `,
        )
      }

      const responseCustomerWarning = await axiosInstance.post(
        '/blacklists/checking',
        {
          name: values.name,
          phoneNumber: values.phone,
          ignoreName: true,
        },
      )

      if (responseCustomerWarning.data.blacklist) {
        isWarning = true
        title.push(`ลูกค้า ${values.name} อยู่ในรายการ Blacklist`)
      }

      if (isWarning) {
        dispatch(
          openModal({
            title: title.join('และ '),
            width: 500,
            content: (
              <ConfirmOrderModal
                content={
                  <>
                    {responseDuplicateOrder?.data?.isDuplicate && (
                      <Box>
                        <Typography mb={3}>
                          รายละเอียดคำสั่งซื้อที่ซ้ำกัน:
                        </Typography>
                        {responseDuplicateOrder?.data?.duplicate?.map(
                          (order) => (
                            <PropertyList>
                              <PropertyListItem
                                align={`horizontal`}
                                label="รหัสคำสั่งซื้อ"
                              >
                                <a
                                  href={`/orders/detail/${order.objectId}`}
                                  target="_blank"
                                >
                                  {order.code.toString()}
                                </a>
                              </PropertyListItem>
                              <Divider />
                              <PropertyListItem
                                align={`horizontal`}
                                label="วันที่คำสั่งซื้อ"
                                value={`${dayjs(order.orderDate).format(
                                  'DD/MM/YYYY',
                                )}`}
                              />
                              <Divider />
                              <PropertyListItem
                                align={`horizontal`}
                                label="วันที่สร้าง"
                                value={`${dayjs(order.createdAt).format(
                                  'DD/MM/YYYY HH:mm',
                                )}`}
                              />
                              <Divider />
                              <PropertyListItem
                                align={`horizontal`}
                                label="ชื่อผู้รับสินค้า"
                                value={order.recipient.name}
                              />
                              <Divider />
                              <PropertyListItem
                                align={`horizontal`}
                                label="หมายเลขโทรศัพท์"
                                value={order.recipient.phone}
                              />
                              <Divider />
                              <PropertyListItem
                                align={`horizontal`}
                                label="ช่องทางการขาย"
                                value={order.distribution?.name ?? '-'}
                              />
                            </PropertyList>
                          ),
                        )}
                      </Box>
                    )}
                  </>
                }
                onConfirm={async () => {
                  await formik.handleSubmit()
                  dispatch(closeModal())
                }}
              />
            ),
          }),
        )
      } else {
        await formik.handleSubmit()
      }
    } catch (e: any) {
      const messageError =
        ERRORS_MESSAGE_MAPPER?.[e.response?.data?.message ?? ''] ||
        'บันทึกข้อมูลไม่สำเร็จ'
      message.error(messageError)
    }
  }
  const formik = useFormik<IOrderForm>({
    initialValues: {
      name: '',
      phone: '',
      address: '',
      subDistrict: '',
      district: '',
      province: '',
      zipcode: '',
      social: '',
      isCOD: 1,
      products: [],
      orderDate: dayjs(),
      distribution: '',
      paymentDate: dayjs(),
      paymentUrl: '',
      note: '',
      commissionUsername: '',
      assignTelesaleBy: '',
    } as IOrderForm,
    validationSchema: getOrderFormValidationSchema(),
    onSubmit: async (values: IOrderForm) => {
      if (values.products.length === 0) {
        message.error('กรุณาเลือกสินค้าอย่างน้อย 1 รายการ')
        return
      }

      if (values.isCOD && getTotal() < 1) {
        message.error(
          'ราคารวมต้องมากกว่า 0 หากกำหนดรูปแบบการชำระเงินเป็น เก็บเงินปลายทาง',
        )
        return
      }

      const phone = values.phone
      if (!phone.startsWith('0')) {
        message.error('เบอร์โทรศัพท์ควรขึ้นต้นด้วย 0 *')
        setIsLoading(false)
        return
      }
      //check phone number format
      const phoneRegex = /^0\d{8,9}$/
      if (!phoneRegex.test(phone)) {
        message.error(
          'รูปแบบเบอร์โทรศัพท์ไม่ถูกต้อง (ต้องมี 9-10 หลัก) และเฉพาะตัวเลขเท่านั้น',
        )
        setIsLoading(false)
        return
      }

      setIsLoading(true)
      try {
        await axiosInstance.post(`/order`, {
          name: values.name.trim() as string,
          phone: values.phone.trim() as string,
          assignTelesaleBy: values.assignTelesaleBy,
          address: {
            address: values.address.trim() as string,
            subDistrict: values.subDistrict.trim() as string,
            district: values.district.trim() as string,
            province: values.province.trim() as string,
            zipcode: `${values.zipcode}`.trim(),
          },
          social: values.social.trim() as string,
          isCOD: !!values.isCOD,
          commissionUsername: values.commissionUsername,
          products: values.products.map((product) => ({
            objectId: product.product?.objectId,
            quantity: product.quantity,
            discount: product.discount,
            size: product.size ?? '',
            free: product.isFree === 'yes',
          })),
          orderDate: values.orderDate,
          distribution: values.distribution,
          paymentDate: values.paymentDate,
          paymentUrl: values.paymentUrl,
          note: values.note,
        })
        setResetAutoComplete(new Date().getTime().toString())
        formik.resetForm()
        setSearchAddress('')
        setSearchUserCommission('')
        setSearchUserTelesales('')
        setSearchDistributionChannel('')
        setFormatAddress('')
        setRemoteArea(initRemoteAdrea)
        message.success('สร้างสินค้าสำเร็จ')
      } catch (e: any) {
        const messageError =
          ERRORS_MESSAGE_MAPPER?.[e.response?.data?.message ?? ''] ||
          'บันทึกข้อมูลไม่สำเร็จ'
        message.error(messageError)
      }
      setIsLoading(false)
    },
  })

  const addressList = useAxios<IAddressThailand[]>({
    method: 'GET',
    url: '/address/thailand-address',
    params: {
      page: 1,
      perPage: 5,
      search: searchAddress,
      startDate: '',
      endDate: '',
    },
  })
  const handleSearchAddress = async (value: string) => {
    setSearchAddress(value)
    await addressList.mutate()
  }

  const userCommissionList = useAxios<PaginationResponseInterface<IUserLists>>({
    method: 'GET',
    url: '/users/merchant',
    params: {
      page: 1,
      perPage: 5,
      search: searchUserCommission,
      startDate: '',
      endDate: '',
    },
  })
  const handleSearchUserCommission = async (value: string) => {
    setSearchUserCommission(value)
    await userCommissionList.mutate()
  }

  const userTelesalesList = useAxios<PaginationResponseInterface<IUserLists>>({
    method: 'GET',
    url: '/users/merchant',
    params: {
      page: 1,
      perPage: 5,
      search: searchUserTelesales,
      startDate: '',
      endDate: '',
    },
  })

  const handleSearchUserTelesales = async (value: string) => {
    setSearchUserTelesales(value)
    await userTelesalesList.mutate()
  }

  // const ordersList = useAxios<
  //   PaginationResponseInterface<IOrder> & { total: OrderSummary }
  // >({
  //   method: 'GET',
  //   url: '/order',
  //   params: {
  //     page: 1,
  //     perPage: 5,
  //     search: searchOrder,
  //     startDate: '',
  //     endDate: '',
  //   },
  // })

  const handleSearchOrder = async (value: string) => {
    setSearchOrder(value)
    // await ordersList.mutate()
  }

  const distributionChannels = useAxios<
    PaginationResponseInterface<IDistributionChannel>
  >({
    method: 'GET',
    url: '/distribution-channels',
    params: {
      page: 1,
      perPage: 5,
      name: searchDistributionChannel,
      startDate: '',
      endDate: '',
    },
  })

  const handleSearchDistributionChannel = async (value: string) => {
    setSearchDistributionChannel(value)
    await distributionChannels.mutate()
  }

  const formatAddressSubmit = async () => {
    try {
      const addressSplit = parseThaiAddress(formatAddress)
      const { name, phone, address, subDistrict, district, province, zipcode } =
        addressSplit
      handleSelectAddress({
        name: name,
        phoneNumber: phone,
        address,
        subDistrict,
        district,
        province,
        postcode: zipcode,
      } as IAddress)

      handleCheckRemoteArea(zipcode, subDistrict)
    } catch (e) {
      return
    }
  }

  const handleSelectAddress = (address?: IAddress) => {
    formik.setFieldValue('name', address?.name ?? '')
    formik.setFieldValue('phone', address?.phoneNumber ?? '')
    formik.setFieldValue('address', address?.address ?? '')
    formik.setFieldValue('subDistrict', address?.subDistrict ?? '')
    formik.setFieldValue('district', address?.district ?? '')
    formik.setFieldValue('province', address?.province ?? '')
    formik.setFieldValue('zipcode', address?.postcode ?? '')
  }

  const handleSelectAddressFromOrder = (order?: IOrder) => {
    formik.setFieldValue('name', order?.recipient.name ?? '')
    formik.setFieldValue('phone', order?.recipient.phone ?? '')
    formik.setFieldValue('address', order?.recipient.address ?? '')
    formik.setFieldValue('subDistrict', order?.recipient.subDistrict ?? '')
    formik.setFieldValue('district', order?.recipient.district ?? '')
    formik.setFieldValue('province', order?.recipient.province ?? '')
    formik.setFieldValue('zipcode', order?.recipient.zipcode ?? '')

    handleCheckRemoteArea(
      order?.recipient.zipcode ?? '',
      order?.recipient.subDistrict ?? '',
    )
  }

  const getTotal = () => {
    return formik.values.products.reduce(
      (total: number, product: IProductsForm) =>
        total +
        (product.product?.price! * product.quantity! - product.discount! || 0),
      0,
    )
  }

  const onChangeDiscount = (index: number, value: any) => {
    const prevCollections = formik.values.products
    prevCollections[index].discount = value
    formik.setFieldValue('products', prevCollections)
  }

  const handleUploadClick = async (event: any) => {
    const file = event.target.files[0]
    const formData = new FormData()
    formData.append('file', file)
    try {
      const response = await axiosInstance.post<any>('/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      if (response.status !== 201) {
        return message.error('อัพโหลดรูปภาพไม่สำเร็จ')
      }
      await formik.setFieldValue('paymentUrl', response.data.url)
      return message.success('อัพโหลดรูปภาพสำเร็จ')
    } catch (e: any) {
      const messageError =
        ERRORS_MESSAGE_MAPPER?.[e.response?.data?.message ?? ''] ||
        'บันทึกข้อมูลไม่สำเร็จ'
      message.error(messageError)
    }
  }

  const handleDeleteCollectionByIndex = (index: number) => {
    const prevCollections = formik.values.products
    formik.setFieldValue(
      'products',
      prevCollections.filter((_, i) => i !== index),
    )
  }

  const handleAddCollection = (value: IProductsForm) => {
    const prevCollections = formik.values.products
    formik.setFieldValue('products', [...prevCollections, value])
  }

  const handleCheckRemoteArea = useCallback(
    async (zipcode: string, subDistrict: string) => {
      if (!zipcode || !subDistrict) {
        return
      }
      const flashProvider = AllowShippingProviderLists(merchant).find(
        (provider) => provider.value === 'flash',
      )
      if (!flashProvider) {
        return
      }
      try {
        const { data } =
          await axiosInstance.get<IRemotesArea>('/remote-area/flash')
        const isRemote = data.remotes.find(
          (remote) =>
            remote.subdistrict === subDistrict && remote.zipcode === zipcode,
        )
        const isTour = data.tours.find(
          (remote) =>
            remote.subdistrict === subDistrict && remote.zipcode === zipcode,
        )
        setRemoteArea({
          ...remoteArea,
          remote: {
            ...remoteArea.remote,
            flash: !!isRemote,
          },
          tour: {
            ...remoteArea.toure,
            flash: !!isTour,
          },
        })
      } catch (e) {}
    },
    [remoteArea, merchant],
  )

  const columns = [
    {
      title: 'รายการสินค้า',
      dataIndex: 'product',
      key: 'name',
      width: 220,
      render: (product: IProduct) => {
        return (
          <Flex vertical>
            <Typography variant="subtitle1" color="text.secondary">
              {product?.name}
            </Typography>
            <Typography variant="subtitle2" color="text.secondary">
              {product?.code}
            </Typography>
          </Flex>
        )
      },
    },
    {
      title: 'ขนาด',
      dataIndex: 'size',
      key: 'size',
      width: 100,
      render: (size: string) => (
        <Typography variant="subtitle2" color="text.secondary">
          {size}
        </Typography>
      ),
    },
    {
      title: 'ราคาต่อชิ้น',
      dataIndex: 'product',
      key: 'price',
      width: 100,
      render: (product: IProduct) => (
        <Typography variant="subtitle2" color="text.secondary">
          {product?.price}
        </Typography>
      ),
    },
    {
      title: 'จำนวน',
      dataIndex: 'quantity',
      key: 'quantity',
      width: 150,
      render: (quantity: number) => (
        <Typography variant="subtitle2" color="text.secondary">
          {quantity}
        </Typography>
      ),
    },
    {
      title: 'ส่วนลด',
      dataIndex: 'key',
      key: 'discount',
      width: 100,
      render: (key: number) => (
        <TextField
          fullWidth
          label="ส่วนลด"
          name="discount"
          value={formik.values.products[key!].discount || ''}
          type={'number'}
          onKeyPress={(e) => {
            if (['+', '-', 'e', '*', '.'].includes(e.key)) {
              e.preventDefault()
            }
          }}
          onChange={(e) => {
            onChangeDiscount(
              key!,
              validateMinMaxValue(
                e.target.value,
                0,
                formik.values.products[key!].product!.price || 1,
              ) || '',
            )
          }}
          helperText={
            formik.touched.products && (formik.errors.products as string)
          }
          error={!!(formik.touched.products && formik.errors.products)}
        />
      ),
    },
    {
      title: 'ราคารวม',
      dataIndex: 'product',
      key: 'total',
      width: 100,
      render: (text: any, record: IProductsForm, index: number) => (
        <Typography variant="subtitle2" color="text.secondary">
          {record.product!.price * record.quantity! - record.discount!}
        </Typography>
      ),
    },
    {
      dataIndex: 'key',
      key: 'delete',
      width: 100,
      render: (key: number) => (
        <Grid container spacing={2} justifyContent="flex-end">
          <Grid item>
            <IconButton onClick={() => handleDeleteCollectionByIndex(key)}>
              <DeleteIcon />
            </IconButton>
          </Grid>
        </Grid>
      ),
    },
  ]

  return (
    <>
      <CircularLoading isLoading={isLoading} />
      <ContentWrapper>
        <OrderFormAddProductModal
          setSearchProductName={setSearchProduct}
          searchProductName={searchProduct}
          onAdd={handleAddCollection}
          isOpen={isModalAddProduct}
          onClose={(visible) => setIsModalAddProduct(visible)}
        />
        <Helmet title="คำสั่งซื้อใหม่" />
        <HeaderContent
          goBack
          title="สร้างคำสั่งซื้อใหม่"
          routes={Menus}
          descriptions="รายการคำสั่งซื้อสินค้า"
        ></HeaderContent>
        <Box sx={{ flexGrow: 1 }} mt={1}>
          <Grid container spacing={2} justifyContent="space-between">
            <Grid item xs={12} lg={4}>
              <Card sx={{ padding: 2 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} lg={12}>
                    <Typography variant={'h6'}>รายการคำสั่งซื้อใหม่</Typography>
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField
                      fullWidth
                      label="ประเภทการค้นหา"
                      value={searchType || 'customer_name'}
                      onChange={(e) => setSearchType(e.target.value)}
                      select
                    >
                      <MenuItem value="customer_name">ชื่อลูกค้า</MenuItem>
                      <MenuItem value="customer_phone">เบอร์โทรศัพท์</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item xs={12} lg={8}>
                    <OrderSelectSearch
                      searchType={searchType}
                      resetAutoComplete={resetAutoComplete}
                      label={'ค้นหาคำสั่งซื้อจากชื่อหรือเบอร์โทรศัพท์'}
                      onSelect={(e) =>
                        handleSelectAddressFromOrder(e?.value as IOrder)
                      }
                    />
                    {/* <SelectSearch<IOrder>
                      resetAutoComplete={resetAutoComplete}
                      label={'ค้นหาคำสั่งซื้อจากชื่อหรือเบอร์โทรศัพท์'}
                      onSelect={(e) =>
                        handleSelectAddressFromOrder(e?.value as IOrder)
                      }
                      search={searchOrder || ''}
                      onSearch={handleSearchOrder}
                      options={
                        (searchOrder &&
                          ordersList.data?.records
                            .filter(
                              (order: IOrder, index: number, self) =>
                                index ===
                                self.findIndex(
                                  (o) =>
                                    o.recipient.name == order.recipient.name &&
                                    o.recipient.phone ==
                                      order.recipient.phone &&
                                    o.status === order.status &&
                                    order.status !== EOrderStatus.CANCLELLED,
                                ),
                            )
                            .map((order: IOrder) => ({
                              label: `${order.recipient.name} ${order.recipient.phone}`,
                              value: order,
                            }))) ||
                        ([] as IOptionSelect<IUserLists>[])
                      }
                    /> */}
                  </Grid>
                  <Grid item xs={12} lg={12}>
                    <TextField
                      fullWidth
                      value={formatAddress}
                      label={`ตัวช่วยจำแนกที่อยู่`}
                      multiline
                      placeholder={`ตัวอย่างการกรอกข้อมูล
คุณมานี มานะ
0831725655
69/429 หมู่ 2 ต.ช้างเผือก อ.เมืองเชียงใหม่ จ.เชียงใหม่ 50300`}
                      rows={5}
                      onChange={(e) => setFormatAddress(e.target.value)}
                    />
                    <Typography mt={1} variant={'body2'} color={'error'}>
                      {' '}
                      ** สามารถใช้คำเต็มหรือตัวย่อได้ เช่น ตำบล/ต. , อำเภอ/อ.
                      หรือ จังหวัด/จ. **{' '}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} lg={12}>
                    <Button
                      fullWidth
                      startIcon={<AutoFixHighIcon />}
                      color="primary"
                      size="medium"
                      variant="contained"
                      onClick={() => formatAddressSubmit()}
                    >
                      นำเข้าที่อยู่
                    </Button>
                  </Grid>
                  <Grid item xs={12} lg={12}>
                    <TextField
                      id="name"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <UserOutlined />
                          </InputAdornment>
                        ),
                      }}
                      fullWidth
                      label={`ชื่อ-นามสกุล`}
                      name="name"
                      helperText={
                        formik.touched.name && (formik.errors.name as string)
                      }
                      error={!!(formik.touched.name && formik.errors.name)}
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.name}
                    />
                  </Grid>
                  <Grid item xs={12} lg={12}>
                    <TextField
                      id="phone"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <PhoneOutlined />
                          </InputAdornment>
                        ),
                      }}
                      fullWidth
                      label={`หมายเลขโทรศัพท์`}
                      name="phone"
                      placeholder={`ตัวอย่างการกรอกข้อมูล 0831725655`}
                      helperText={
                        formik.touched.phone && (formik.errors.phone as string)
                      }
                      error={!!(formik.touched.phone && formik.errors.phone)}
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.phone}
                    />
                  </Grid>
                  <Grid item xs={12} lg={12}>
                    <TextField
                      id={'address'}
                      multiline
                      fullWidth
                      label={`ที่อยู่`}
                      name="address"
                      rows={5}
                      placeholder={`บ้านเลขที่, หมู่ ชั้นหรือซอย `}
                      helperText={
                        formik.touched.address &&
                        (formik.errors.address as string)
                      }
                      error={
                        !!(formik.touched.address && formik.errors.address)
                      }
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.address}
                    />
                  </Grid>
                  <Grid item xs={12} lg={12}>
                    <SelectSearch<IAddressThailand>
                      resetAutoComplete={resetAutoComplete}
                      label={'ค้นหาที่อยู่'}
                      onSelect={(e) => {
                        formik.setFieldValue(
                          'subDistrict',
                          e?.value.subDistrict,
                        )
                        formik.setFieldValue('district', e?.value.district)
                        formik.setFieldValue('province', e?.value.province)
                        formik.setFieldValue('zipcode', e?.value.zipcode)
                        handleCheckRemoteArea(
                          e?.value.zipcode ?? '',
                          e?.value.subDistrict ?? '',
                        )
                      }}
                      search={searchAddress}
                      onSearch={handleSearchAddress}
                      options={
                        addressList.data?.map((address: IAddressThailand) => ({
                          label: `${address.subDistrict} ${address.district} ${address.province} ${address.zipcode}`,
                          value: address,
                        })) || ([] as IOptionSelect<IAddressThailand>[])
                      }
                    />
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <TextField
                      id="province"
                      fullWidth
                      label="จังหวัด"
                      name="province"
                      helperText={
                        formik.touched.province &&
                        (formik.errors.province as string)
                      }
                      error={
                        !!(formik.touched.province && formik.errors.province)
                      }
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.province}
                    />
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <TextField
                      id="district"
                      fullWidth
                      label="อำเภอ"
                      name="district"
                      helperText={
                        formik.touched.district &&
                        (formik.errors.district as string)
                      }
                      error={
                        !!(formik.touched.district && formik.errors.district)
                      }
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.district}
                    />
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <TextField
                      id="subDistrict"
                      fullWidth
                      label="ตำบล"
                      name="subDistrict"
                      helperText={
                        formik.touched.subDistrict &&
                        (formik.errors.subDistrict as string)
                      }
                      error={
                        !!(
                          formik.touched.subDistrict &&
                          formik.errors.subDistrict
                        )
                      }
                      onBlur={() => {
                        handleCheckRemoteArea(
                          formik.values.zipcode,
                          formik.values.subDistrict,
                        )
                      }}
                      onChange={formik.handleChange}
                      value={formik.values.subDistrict}
                    />
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <TextField
                      id="zipcode"
                      fullWidth
                      label="รหัสไปรษณีย์"
                      name="zipcode"
                      helperText={
                        formik.touched.zipcode &&
                        (formik.errors.zipcode as string)
                      }
                      error={
                        !!(formik.touched.zipcode && formik.errors.zipcode)
                      }
                      onBlur={() => {
                        handleCheckRemoteArea(
                          formik.values.zipcode,
                          formik.values.subDistrict,
                        )
                      }}
                      onChange={formik.handleChange}
                      value={formik.values.zipcode}
                    />
                  </Grid>
                  <Grid item xs={12} lg={12}>
                    {Object.keys(remoteArea.remote).map((key: string) => {
                      if (remoteArea.remote?.[key]) {
                        return (
                          <Typography fontSize={14} color={'error'}>
                            ** ที่อยู่นี้เป็นพื้นที่ห่างไกลของ{' '}
                            {key.toUpperCase()} **
                          </Typography>
                        )
                      }
                      if (remoteArea.tour?.[key]) {
                        return (
                          <Typography fontSize={14} color={'error'}>
                            ** ที่อยู่นี้เป็นพื้นที่ท่องเที่ยวของ{' '}
                            {key.toUpperCase()} **
                          </Typography>
                        )
                      }
                      return <></>
                    })}
                  </Grid>
                  <Grid item xs={12} lg={12}>
                    <TextField
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <FacebookOutlined />
                          </InputAdornment>
                        ),
                      }}
                      fullWidth
                      label={`Facebook`}
                      name="social"
                      helperText={
                        formik.touched.social &&
                        (formik.errors.social as string)
                      }
                      error={!!(formik.touched.social && formik.errors.social)}
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.social}
                    />
                  </Grid>
                  <Grid item xs={12} lg={12}>
                    {/* <SelectSearch<IDistributionChannel>
                      resetAutoComplete={resetAutoComplete}
                      label={'เลือกช่องทางการขาย'}
                      onSelect={(e) =>
                        formik.setFieldValue('distribution', e?.value.objectId)
                      }
                      search={searchDistributionChannel}
                      onSearch={handleSearchDistributionChannel}
                      name="distribution"
                      helperText={
                        formik.touched.distribution &&
                        (formik.errors.distribution as string)
                      }
                      error={
                        !!(
                          formik.touched.distribution &&
                          formik.errors.distribution
                        )
                      }
                      onBlur={formik.handleBlur}
                      options={
                        distributionChannels.data?.records.map(
                          (distributionChannel: IDistributionChannel) => ({
                            label: distributionChannel.name,
                            image:
                              ImageLinks[
                                `LOGO_${distributionChannel.type.toUpperCase()}` as LogoTypeSocial
                              ],
                            value: distributionChannel,
                          }),
                        ) || ([] as IOptionSelect<IDistributionChannel>[])
                      }
                    /> */}
                    <ChannelSelectSearch
                      resetAutoComplete={resetAutoComplete}
                      multiple={false}
                      label={'เลือกช่องทางการขาย'}
                      onSelect={(e) =>
                        formik.setFieldValue('distribution', e?.value.objectId)
                      }
                      name="distribution"
                      helperText={
                        formik.touched.distribution &&
                        (formik.errors.distribution as string)
                      }
                      error={
                        !!(
                          formik.touched.distribution &&
                          formik.errors.distribution
                        )
                      }
                      onBlur={formik.handleBlur}
                    />
                  </Grid>
                  <Grid item xs={12} lg={12}>
                    <TextField
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <ReportGmailerrorredIcon />
                          </InputAdornment>
                        ),
                      }}
                      fullWidth
                      label={`หมายเหตุ`}
                      name="note"
                      helperText={
                        formik.touched.note && (formik.errors.note as string)
                      }
                      error={!!(formik.touched.note && formik.errors.note)}
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.note}
                    />
                  </Grid>
                </Grid>
              </Card>
            </Grid>
            <Grid item xs={12} lg={8}>
              <Card sx={{ padding: 2 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} lg={12}>
                    <Grid
                      container
                      spacing={2}
                      justifyContent={'space-between'}
                      alignItems={'center'}
                    >
                      <Grid item>
                        <Typography variant={'h6'}>รายการสินค้า</Typography>
                      </Grid>
                      <Grid item>
                        <Button
                          startIcon={<AddIcon />}
                          color="warning"
                          size="medium"
                          variant="contained"
                          onClick={() =>
                            setIsModalAddProduct(!isModalAddProduct)
                          }
                        >
                          เพิ่มสินค้า
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} lg={12}>
                    <Table
                      columns={columns}
                      dataSource={formik.values.products?.map(
                        (product: IProductsForm, index: number) => {
                          return {
                            ...product,
                            key: index,
                          }
                        },
                      )}
                      bordered
                      pagination={{ hideOnSinglePage: true }}
                    />
                  </Grid>
                  <Grid container justifyContent={'flex-end'} mt={2}>
                    <Grid item>
                      <Typography variant="subtitle2" color="text.secondary">
                        ราคารวม: {getTotal().toLocaleString()} บาท
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    {/* <SelectSearch<IUserLists>
                      resetAutoComplete={resetAutoComplete}
                      label={'ลงออเดอร์ (ค่าคอม) ให้พนักงาน'}
                      onSelect={(e) =>
                        formik.setFieldValue(
                          'commissionUsername',
                          e?.value.username,
                        )
                      }
                      search={searchUserCommission}
                      onSearch={handleSearchUserCommission}
                      options={
                        userCommissionList.data?.records
                          .filter(
                            (userCommission: IUserLists) =>
                              userCommission.isAvailable,
                          )
                          .map((userCommission: IUserLists) => ({
                            label: userCommission.name,
                            image: userCommission.image,
                            value: userCommission,
                          })) || ([] as IOptionSelect<IUserLists>[])
                      }
                    /> */}

                    <UserSelectSearch
                      resetAutoComplete={resetAutoComplete}
                      label={'ลงออเดอร์ (ค่าคอม) ให้พนักงาน'}
                      onSelect={(e) =>
                        formik.setFieldValue(
                          'commissionUsername',
                          e?.value.username,
                        )
                      }
                      name="commissionUsername"
                    />
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    {/* <SelectSearch<IUserLists>
                      resetAutoComplete={resetAutoComplete}
                      label={
                        'เลือกผู้ดูแล Telesale (กรุณาเว้นว่างไว้ หากไม่ต้องการกำหนด)'
                      }
                      onSelect={(e) =>
                        formik.setFieldValue(
                          'assignTelesaleBy',
                          e?.value.username,
                        )
                      }
                      search={searchUserTelesales}
                      onSearch={handleSearchUserTelesales}
                      options={
                        userTelesalesList.data?.records
                          .filter(
                            (userTelesales: IUserLists) =>
                              userTelesales.isAvailable,
                          )
                          .map((userTelesales: IUserLists) => ({
                            label: userTelesales.name,
                            image: userTelesales.image,
                            value: userTelesales,
                          })) || ([] as IOptionSelect<IUserLists>[])
                      }
                    /> */}
                    <UserSelectSearch
                      resetAutoComplete={resetAutoComplete}
                      label={
                        'เลือกผู้ดูแล Telesale (กรุณาเว้นว่างไว้ หากไม่ต้องการกำหนด)'
                      }
                      onSelect={(e) =>
                        formik.setFieldValue(
                          'assignTelesaleBy',
                          e?.value.username,
                        )
                      }
                      name="assignTelesaleBy"
                    />
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <Select
                      id="isCOD"
                      name="isCOD"
                      placeholder="การชำระเงิน"
                      value={formik.values.isCOD}
                      onChange={formik.handleChange}
                      fullWidth
                    >
                      <MenuItem value={1}>เก็บเงินปลายทาง</MenuItem>
                      <MenuItem value={0}>ชำระเงินผ่านธนาคาร</MenuItem>
                    </Select>
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        format={ONLY_DATE_FORMAT}
                        //disableFuture
                        label="วันที่สั่งซื้อ"
                        name="orderDate"
                        value={
                          formik.values.orderDate
                            ? dayjs(formik.values.orderDate)
                            : null
                        }
                        onChange={(e) => {
                          formik.setFieldValue('orderDate', e?.format())
                        }}
                        sx={{ width: '100%' }}
                        slotProps={{
                          textField: {
                            helperText:
                              formik.touched.orderDate &&
                              (formik.errors.orderDate as string),
                            error: !!(
                              formik.touched.orderDate &&
                              formik.errors.orderDate
                            ),
                            onBlur: formik.handleBlur,
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </Grid>
                  {formik.values.isCOD === 0 && (
                    <>
                      <Grid item xs={12} lg={6}>
                        <InputUpload
                          onRemove={() =>
                            formik.setFieldValue('paymentUrl', '')
                          }
                          handleUploadClick={handleUploadClick}
                          imageUrl={formik.values.paymentUrl ?? ''}
                        />
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            format={ONLY_DATE_FORMAT}
                            // disableFuture
                            label="วันที่ชำระ"
                            name="paymentDate"
                            value={
                              formik.values.paymentDate
                                ? dayjs(formik.values.paymentDate)
                                : null
                            }
                            onChange={(e) => {
                              formik.setFieldValue('paymentDate', e?.format())
                            }}
                            sx={{ width: '100%' }}
                            slotProps={{
                              textField: {
                                helperText:
                                  formik.touched.paymentDate &&
                                  (formik.errors.paymentDate as string),
                                error: !!(
                                  formik.touched.paymentDate &&
                                  formik.errors.paymentDate
                                ),
                                onBlur: formik.handleBlur,
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>
                    </>
                  )}
                </Grid>
                <Grid container justifyContent={'flex-end'} sx={{ mt: 2 }}>
                  <Grid item>
                    <Button
                      color="primary"
                      onClick={() => handleCheckCustomerWarning(formik.values)}
                      size="large"
                      variant="contained"
                      startIcon={<AddIcon />}
                    >
                      สร้างออเดอร์
                    </Button>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </ContentWrapper>
    </>
  )
}

export default OrderCreatePage
